import { useMessageToState } from "./useMessageToState";

function getState(editor: eXpress.core.IEditor) {
	return editor.definition?.selectedAttributeCode;
}

export function useAttribute() {
	// No filterMessage used, it would slow down because getState is simple
	return useMessageToState({
		name: "useAttribute",
		getState,
	});
}
